import moment from 'moment';
import PriceHistorySegment from '../types/PriceHistorySegment';
import PriceChartItem from '../types/PriceChartItem';

export const transformData = (data: PriceHistorySegment | null, sourceOwnerId: string) => {
  if (!data) {
    return [];
  }
  return Object.entries(data).flatMap(([date, ownerPrice], i) =>
    ownerPrice.map(({ ownerId, ownerName, price }) => ({
      day: date,
      date,
      key: `${i}-${ownerName}`,
      type: ownerName,
      isOwner: sourceOwnerId === String(ownerId),
      value: price,
      ownerId,
    }))
  );
};

export const getCompetitors = (data: PriceChartItem[] | null): string[] => {
  if (!data) {
    return [];
  }

  return [...new Set(data.filter((item) => !item.isOwner).map((item) => item.type))];
};

export const filterChartData = (
  data: PriceChartItem[] | null,
  startDate: string,
  endDate: string,
  competitors: string[]
) => {
  if (data && startDate && endDate) {
    return data
      .filter((item) => {
        return (
          (competitors.includes(item.type) || item.isOwner) &&
          moment(item.date).isSameOrAfter(startDate) &&
          moment(item.date).isSameOrBefore(endDate)
        );
      })
      .sort((a, b) => a.date.localeCompare(b.date));
  }

  return [];
};
